export const alertModalTranslationEN = {
  Alert_Modal: {
    close: 'Close',
  },
};
